import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Popper,
  Paper,
  Typography,
  ClickAwayListener,
} from '@mui/material';
import { trendingCollections } from '../data/collections';

export default function SearchBar({ StyledInputBase }) {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const filteredCollections = trendingCollections.filter(collection =>
    collection.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setAnchorEl(event.currentTarget);
    setShowSuggestions(true);
  };

  const handleSuggestionClick = (collection) => {
    navigate(`/collection/${collection.id}`);
    setShowSuggestions(false);
    setSearchTerm('');
  };

  const handleClickAway = () => {
    setShowSuggestions(false);
  };

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <StyledInputBase
        placeholder="Search items, collections, and accounts…"
        inputProps={{ 'aria-label': 'search' }}
        value={searchTerm}
        onChange={handleSearchChange}
      />
      <Popper
        open={showSuggestions && searchTerm.length > 0}
        anchorEl={anchorEl}
        placement="bottom-start"
        style={{ width: anchorEl?.offsetWidth, zIndex: 1400 }}
      >
        <ClickAwayListener onClickAway={handleClickAway}>
          <Paper 
            elevation={3}
            sx={{ 
              mt: 1,
              maxHeight: '400px',
              overflow: 'auto',
              backgroundColor: 'background.paper',
            }}
          >
            {filteredCollections.map((collection) => (
              <Box
                key={collection.id}
                onClick={() => handleSuggestionClick(collection)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  p: 1.5,
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: 'action.hover',
                  },
                }}
              >
                <img
                  src={collection.image}
                  alt=""
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 4,
                    objectFit: 'cover'
                  }}
                />
                <Typography variant="body1">
                  {collection.name}
                </Typography>
              </Box>
            ))}
            {filteredCollections.length === 0 && (
              <Box sx={{ p: 2 }}>
                <Typography color="text.secondary">
                  No collections found
                </Typography>
              </Box>
            )}
          </Paper>
        </ClickAwayListener>
      </Popper>
    </Box>
  );
}
